import { render } from "./FileView.vue?vue&type=template&id=70ce5241&scoped=true"
import script from "./FileView.vue?vue&type=script&lang=js"
export * from "./FileView.vue?vue&type=script&lang=js"

import "./FileView.vue?vue&type=style&index=0&id=70ce5241&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70ce5241"

export default script